import styled, { css } from 'styled-components';
import media from '../../constants/media';
import { Column, Columns } from '../base/grid';
import DynamicRspImage from '../base/images/dynamicRspImageBg';

export const Wrapper = styled.div`
	display: flex;
	align-items: stretch;
	min-height: 55rem;
	margin: 6rem 0;

	${media.tablet`
		margin-bottom: 18rem;
	`};
`;

export const ShowcaseSectionColumns = styled(Columns)`
	width: 100%;
`;

export const ImageColumn = styled(Column)`
	${({ right }) =>
		right &&
		css`
			${media.desktopSmall`
				order: 2;
			`}
		`};
`;

export const ContentColumn = styled(Column)`
	${({ left }) =>
		left &&
		css`
			order: 1;
		`};
`;

export const ShowcaseSectionImage = styled(DynamicRspImage)`
	height: 100%;
	padding-top: 60%;

	${media.tablet`
		padding-top: 0;
	`};

	${({ containImage }) =>
		containImage &&
		css`
			background-size: contain;
			background-repeat: no-repeat;
		`}
`;

export const Subtitle = styled.div`
	font-size: 1.5rem;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;

	${media.desktopSmall`
        max-width: 42rem;
	`};

	${({ left }) =>
		!left &&
		css`
			${media.tablet`
				float: right;
			`};
		`}
`;

export const ButtonWrapper = styled.div`
	margin-top: 3rem;
`;

export const HeroVideo = styled.video`
	width: 100%;
`;

export const VideoSource = styled.source``;
